import { systemInfoCapabilities } from 'src/js/data/systemInfo';
import { UpdateDateTimeRequest } from 'src/js/model/api/request/update-date-time-request';
import { DateTime } from 'src/js/pages/settings/datetime/date-and-time-view-model';

export const createUpdateDateTimeRequest = (model: Partial<DateTime>): UpdateDateTimeRequest => {
  let request: Partial<UpdateDateTimeRequest> = {};

  if (model.ntp) {
    request = {
      timezone: model.timezone,
      ntp: model.ntp,
      server: model.server,
    };
  } else {
    request = {
      timezone: model.timezone,
      ntp: model.ntp,
      time_text: model.time?.format('M D YYYY HH:mm:ss'),
    };
  }

  if (systemInfoCapabilities.is2110()) {
    request.announcementInterval = model.announcementInterval;
    request.announcementTimeout = model.announcementTimeout;
    request.delayMechanism = model.delayMechanism;
    request.domainNumber = model.domainNumber;
    request.syncInterval = model.syncInterval;
  }

  return request as UpdateDateTimeRequest;
};
